import React, { useEffect, useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { useForm, FormProvider } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as yup from 'yup';
import ProductCatalogBasicInformation from './NewProductCatalogForms/ProductCatalogBasicInformation';
import ProductCatalogHeader from './NewProductCatalogForms/ProductCatalogHeader';
import ProductCatalogUpload from './NewProductCatalogForms/ProductCatalogUpload';
import ProductCatalogDetails from './NewProductCatalogForms/ProductCatalogDetails';
import ProductCatalogType from './NewProductCatalogForms/ProductCatalogType';
import ProductCatalogPrice from './NewProductCatalogForms/ProductCatalogPrice';
import ProductCatalogTags from './NewProductCatalogForms/ProductCatalogTags';
import { useMutation } from '@apollo/client';
import { PRODUCT_CATALOG_CREATE } from '../../../lib/mutations';
import axios from 'axios';
import Resizer from 'react-image-file-resizer';

const schema = yup
  .object({
    name: yup.string().required('Энэ талбарыг оруулна уу!'),
    description: yup.string().required('Энэ талбарыг оруулна уу!'),
    price: yup.string().required('Энэ талбарыг оруулна уу!'),
    quantity: yup.string().required('Энэ талбарыг оруулна уу!')
  })
  .required();

const ProductCatalogAdd = () => {
  const navigage = useNavigate();
  const [postProductCatalogData, { data }] = useMutation(
    PRODUCT_CATALOG_CREATE
  );
  const submittedValues = {};
  const methods = useForm({
    resolver: yupResolver(schema)
  });
  const { handleSubmit, reset } = methods;
  const [files, setFiles] = useState([]);
  const [imageUrls, setImageUrls] = useState([]);
  const [loading, setLoading] = useState(false);

  const imageUploader = image => {
    setLoading(true);
    Resizer.imageFileResizer(
      image,
      800,
      600,
      'WEBP',
      100,
      0,
      uri => {
        axios
          .post(`${process.env.REACT_APP_FILE_URL}/uploadimage`, {
            image: uri
          })
          .then(response => {
            if (response.data?.url && response.data?.public_id) {
              const newImageUrl = {
                url: String(response?.data?.url),
                public_id: String(response?.data?.public_id),
                bucketname: image.name
              };

              setImageUrls(prevUrls => [...prevUrls, newImageUrl]);
              setLoading(false);
            }
          })
          .catch(error => {
            console.log('CLOUDINARY UPLOAD FAILED', error);
          });
      },
      'base64',
      400,
      300
    );
  };

  const onSubmit = data => {
    if (Object.keys(data).length === 0) {
      toast.warning('Та мэдээллээ гүйцэт оруулна уу', {
        theme: 'colored'
      });
    } else {
      postProductCatalogData({
        variables: {
          input: {
            price: parseFloat(data.price),
            description: data.description,
            image: imageUrls,
            quantity: parseFloat(data.quantity),
            name: data.name,
            tags:
              data.tags && Array.isArray(data.tags) && data.tags.length > 0
                ? [...data.tags.map(item => item.value)]
                : []
          }
        }
      });
      const keys = Object.keys(data);
      for (const key of keys) {
        submittedValues[key] = '';
      }
      reset({ ...submittedValues });
    }
  };

  useEffect(() => {
    if (data) {
      if (data?.productCatalogCreate?.status?.code === 200) {
        toast.success(`Амжиллтай илгээлээ`, {
          theme: 'colored'
        });
        navigage(
          `/product-catalog/product-update/${data?.productCatalogCreate?.data?._id}`
        );
      } else {
        toast.warning(`${data?.productCatalogCreate?.status?.moreInfo}`, {
          theme: 'colored'
        });
      }
    }
  }, [data]);

  const handleRemove = path => {
    let removeItem = '';
    imageUrls.forEach(item => {
      if (item.bucketname === path) {
        removeItem = item.public_id;
      }
    });
    setFiles(files.filter(file => file.path !== path));
    const updatedImageUrls = imageUrls.filter(
      image => image.bucketname !== path
    );
    setImageUrls(updatedImageUrls);
    if (removeItem) {
      axios
        .post(`${process.env.REACT_APP_FILE_URL}/removeimage`, {
          public_id: removeItem
        })
        .then(response => {
          console.log(response);
        })
        .catch(error => {
          console.log('CLOUDINARY UPLOAD FAILED', error);
        });
    }
  };

  return (
    <FormProvider {...methods}>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Row className="g-3">
          <Col xs={12}>
            <ProductCatalogHeader />
          </Col>
          <Col lg={8}>
            <ProductCatalogBasicInformation />
            <ProductCatalogUpload
              setFiles={setFiles}
              files={files}
              imageUploader={imageUploader}
              handleRemove={handleRemove}
              loading={loading}
            />
            <ProductCatalogDetails />
          </Col>
          <Col lg={4}>
            <div className="sticky-sidebar">
              <ProductCatalogType />
              <ProductCatalogPrice />
              <ProductCatalogTags />
            </div>
          </Col>
        </Row>
      </Form>
    </FormProvider>
  );
};

export default ProductCatalogAdd;
